import { render, staticRenderFns } from "./PasswordResetPopup.vue?vue&type=template&id=5c836990&"
import script from "./PasswordResetPopup.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPopup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPopup.vue?vue&type=style&index=0&id=5c836990&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports